import workspaceQuery from 'graphql/queries/nominal/NominalTransactionWorkspaceQuery.graphql';
import bankWorkspaceQuery from 'graphql/queries/nominal/NominalBankTransactionWorkspaceQuery.graphql';
import listQuery from 'graphql/queries/nominal/NominalTransactionListQuery.graphql';
import instanceQuery from 'graphql/queries/nominal/NominalTransactionQuery.graphql';
import defaultQuery from 'graphql/queries/nominal/NominalTransactionDefault.graphql';
import fragment from 'graphql/fragments/nominal/NominalTransactionFragment.graphql';
import aggregateQuery from 'graphql/queries/nominal/NominalTransactionAggregateQuery.graphql';

const NominalTransaction = {
  type: 'NominalTransaction',
  title: 'Nominal Transactions',
  workspaceUrl: '/Nominal/NominalTransaction/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  bankWorkspace: bankWorkspaceQuery,
  default: defaultQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'nominal',
  },
  fragment,
  aggregate: aggregateQuery,
  screenReference: 'NOMINAL_TRANSACTIONS',
  operations: 0,
};

export const NominalBankTransaction = { ...NominalTransaction, workspace: bankWorkspaceQuery };
export default NominalTransaction;
